import { createConstantRetryStrategy, withRetries } from '@genially/utils';

import { calculateServerIndex } from '../util/calculateServerIndex';
import { getP2pAxiosClient } from './utils/getP2pAxiosClient';

const isAlive = async (serverIndex?: number): Promise<boolean> => {
  try {
    await getP2pAxiosClient(serverIndex).get('/health-check');
    return true;
  } catch (error) {
    return false;
  }
};

const getAvailableServers = async (): Promise<number> => {
  return withRetries(
    async () => {
      return getP2pAxiosClient()
        .get('/available-servers')
        .then(response => response.data.availableServers);
    },
    createConstantRetryStrategy({ wait: 2500 }),
  );
};

export const P2pRestClient = {
  getAvailableServers,
  with: (value: string) => {
    return {
      isAlive: async () => {
        const serverIndex = await calculateServerIndex(value);

        return isAlive(serverIndex);
      },
    };
  },
};
